import { makeAutoObservable, runInAction } from 'mobx'

import { analyticsSession } from '../../common/utils/Analytics'

import { CopyStore } from './CopyStore'
import { InsightsMicroWidgetStore } from './InsightsMicroWidgetStore'

import type { AnalyticSession } from '../analytics'

export class AppStore {
  copyStore
  endpoint = '/'
  insightsMicroWidgetStore
  session: AnalyticSession | null = null
  token = ''

  isInitialized = false

  constructor() {
    this.copyStore = new CopyStore()
    this.insightsMicroWidgetStore = new InsightsMicroWidgetStore()
    makeAutoObservable(this)
  }

  initialize = async (endpoint: string, token: string, logOutUser: () => void) => {
    await this.copyStore.initialize(endpoint, token)
    await this.insightsMicroWidgetStore.initialize(endpoint, token, logOutUser)
    const session = await analyticsSession(endpoint, token, '1.0.0', 'Micro Insights Carousel')

    runInAction(() => {
      this.session = session
      this.isInitialized = true
    })
  }
}
